var app = angular.module("leonardo");

var DownloadWarningDialog = function($scope) {

  $scope.folder = $scope.ngDialogData.folder;

  $scope.submit = function() {
    $scope.confirm($scope.folder);
  };
};

app.controller('DownloadWarningDialog', ['$scope', DownloadWarningDialog]);
